import React, { useEffect } from 'react'
import { styled } from 'linaria/react'
import { css, cx } from 'linaria'
import { calculateDaysSinceDate } from '../../Core/Util/Helpers'
import { theme } from '../../Theme'
import { useIntl } from '@jetshop/intl'

const QuestionWrapper = styled.div`
   .post-info p {
      font-size: 1rem;
      font-weight: 400;
      margin-left: 1rem;
      font-weight: 600;
      color: ${theme.colors.darkgrey};
      span {
         color: ${theme.colors.textLight};
         font-weight: 300;
      }
   }

   .main-question-title {
      font-size: 1rem;
      font-weight: 600;
   }

   .sub-question-content {
   }

   .answer-container {
      background-color: #f2f6f8;
      border-radius: 10px;
   }

   .with-break-spaces {
      white-space: break-spaces;
   }

   // Overflow hidden-wrapper on review-images, preserve same width and height on all images
   .review-img-gallery > .review-img-wrapper {
      width: 80px;
      height: 80px;
      overflow: hidden;
      position: relative;
   }

   .review-img-gallery img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
   }


   .user-avatar-image {
      border-radius: 50%;
      width: ${props => props.breakpointsWidth?.default ?? '50px'};
      height: ${props => props.breakpointsWidth?.default ?? '50px'};

      ${theme.above.lg} {
         width: ${props => props.breakpointsWidth?.lg ?? '70px'};
         height: ${props => props.breakpointsWidth?.lg ?? '70px'};
      }
   }
`

const UserAvatar = styled.div`
   width: ${props => props.breakpointsWidth?.default ?? '50px'};
   height: ${props => props.breakpointsWidth?.default ?? '50px'};
   background: ${props => props.avatarBg ?? 'gray'};
   border-radius: 50%;
   color: #fff;
   font-size: 2rem;
   font-weight: 700;
   text-align: center;
   aspect-ratio: 1/1;
   position: relative;
   display: flex;
   justify-content: center;
   align-content: center;
   flex-wrap: wrap;

   ${theme.above.lg} {
      width: ${props => props.breakpointsWidth?.lg ?? '70px'};
      height: ${props => props.breakpointsWidth?.lg ?? '70px'};
   }

   .user-verified svg {
      position: absolute;
      width: 2rem;
      height: 2rem;
      right: -0.25rem;
      bottom: -0.25rem;
      padding: 2px;
      background: #1d9bf0;
      border-radius: 50%;
      border: 4px solid #fff;
   }
`

const avatarWidthBreakpoints = { default: '50px', lg: '60px' }
const avatarIndentationWidth = css`
   margin-left: 0px;

   ${theme.above.sm} {
      margin-left: ${avatarWidthBreakpoints?.default ?? '0px'};
   }
   ${theme.above.lg} {
      margin-left: ${avatarWidthBreakpoints?.lg ?? '0px'};
   }
`
const postHeaderBsClasses = 'd-flex pb-2 m-0 align-items-center'

const VERKTYGSBODEN_COMAPANY_NAME_ADDITION = 'Verktygsboden'

const ProductQuestionItem = ({ question }) => {
   const t = useIntl()
   const { author, date, title, extract, responses } = question ?? {}

   // First answerItem
   const {
      // date: responseDate,
      icon: responseProfileImgSrc,
      images: responseImages,
      name: responseName,
      response: responseMsg,
   } = (responses ?? [])[0] ?? {}

   return (
      <QuestionWrapper breakpointsWidth={avatarWidthBreakpoints}>
         <div className={postHeaderBsClasses}>
            <UserAvatar
               breakpointsWidth={avatarWidthBreakpoints}
               avatarBg={theme?.colors?.greyMedium}
            >
               {author?.charAt(0)}
            </UserAvatar>
            <div className="post-info">
               <p className="mb-0">
                  {author}{' '}
                  {date && (
                     <span>
                        • {calculateDaysSinceDate(date)} {t('days ago')}{' '}
                     </span>
                  )}
               </p>
            </div>
         </div>

         <div className={cx(avatarIndentationWidth, 'mb-3')}>
            <div className="main-question-title mb-2">{title ?? <br></br>}</div>
            {extract && (
               <div className="sub-question-content">
                  {extract ?? <br></br>}
               </div>
            )}
         </div>

         <div className={cx(avatarIndentationWidth, 'answer-wrapper')}>
            <div className="answer-container p-3">
               <div className={postHeaderBsClasses}>
                  {responseProfileImgSrc ? (
                     <img
                        src={responseProfileImgSrc}
                        className="user-avatar-image"
                        alt="User avatar"
                     />
                  ) : (
                     <UserAvatar
                        breakpointsWidth={avatarWidthBreakpoints}
                        avatarBg={theme?.colors?.siteBlue}
                     >
                        {/* {responseName.charAt(0)} */}V
                        <div className="user-verified">
                           <svg
                              width="24px"
                              height="24px"
                              strokeWidth="2.5"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              color="#ffffff"
                           >
                              <path
                                 d="M5 13l4 4L19 7"
                                 stroke="#ffffff"
                                 strokeWidth="2.5"
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                              ></path>
                           </svg>
                        </div>
                     </UserAvatar>
                  )}
                  <div className="post-info">
                     <p className="mb-0">
                        {`${responseName ? responseName + ', ' : ''}`}
                        {VERKTYGSBODEN_COMAPANY_NAME_ADDITION}
                        {/* Timestamp here? */}
                        {/* <span>
                           • {calculateDaysSinceDate(responseDate)} {t('days ago')}{' '}
                        </span> */}
                     </p>
                  </div>
               </div>

               <div className={cx(avatarIndentationWidth)}>
                  <div style={{ whiteSpace: 'break-spaces' }}>
                     {responseMsg}
                  </div>
               </div>

               {responseImages && responseImages.length > 0 && (
                  <div className={cx(avatarIndentationWidth, 'images-wrapper')}>
                     <div className="review-img-gallery d-flex gap-2 mt-32 flex-wrap">
                        {responseImages.map((imgItem, index) => (
                           <a
                              key={index}
                              className="review-img-wrapper align-content-center"
                              href={imgItem?.medium}
                              // If imgItem?.medium is falsy unset pointer-events and target
                              target={imgItem?.medium ? '_blank' : undefined}
                              without rel="noreferrer"
                              style={{
                                 pointerEvents: imgItem?.medium
                                    ? 'auto'
                                    : 'none',
                              }}
                           >
                              <img
                                 src={imgItem?.icon}
                                 alt={`Review ${index}`}
                                 className="review-img-gallery-item"
                              />
                           </a>
                        ))}
                     </div>
                  </div>
               )}
            </div>
            <hr style={{opacity: '0.15'}} className="my-4"></hr>
         </div>
      </QuestionWrapper>
   )
}

export default ProductQuestionItem
